import React, { useEffect } from "react";
import { Button, Form, Space, Input, InputNumber } from "antd";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ProductInterface } from "src/store/gh_market/productsSlice";

type dataType = {
  products: ProductInterface[];
  bundle_id: number;
}

interface propsInterface {
  onFinish: Function;
  data: dataType;
}

const _ListForm = ({ onFinish, data }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [data, form]);

  const ProductField = ({ name, remove, restField }: any) => (
    <Space style={{ display: 'flex', marginBottom: 2 }}>
      <Form.Item
        {...restField}
        name={[name, 'product_id']}
        rules={[{ required: true, message: 'Missing product_id' }]}
      >
        <Input placeholder="com.example.100coins" />
      </Form.Item>

      <Form.Item
        {...restField}
        name={[name, 'value']}
        rules={[{ required: true, message: 'Missing value' }]}
      >
        <InputNumber
          min={0}
          step={50}
          placeholder="100"
        />
      </Form.Item>

      <MinusCircleOutlined onClick={() => remove(name)} className='v-mb-20' />
    </Space>
  );

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form'
      autoComplete="off"
      initialValues={data}
    >
      <Form.List name="products">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
                <ProductField
                  key={key}
                  name={name}
                  remove={remove}
                  restField={restField}
                />
              )
            )}

            <Form.Item>
              <Button
                type="dashed"
                onClick={add}
                block
                icon={<PlusOutlined />}
              >
                Add product
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _ListForm;
